export default __webpack_public_path__ + "static/media/Banner - Elevate Pro - Black-1.1c6c50b3.jpg";